import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { map, switchMap } from 'rxjs';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { GalleryService } from '../../../services/gallery.service';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-gallery-public-view-only-access-item',
  imports: [AccessItemComponent, AccessItemHeaderComponent, AccessItemCtaComponent, SwitchComponent, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-public-view-only-access-item.component.html',
  styleUrl: './gallery-public-view-only-access-item.component.scss',
})
export class GalleryPublicViewOnlyAccessItemComponent {
  private galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  galleryPermissions = input.required<GalleryDto['permissions']>();
  viewOnly = model(false);

  private _viewOnly = toSignal(
    toObservable(this.gallery).pipe(
      switchMap(gallery => {
        return this.galleryService
          .getEffectivePublicAccessLevel(gallery)
          .pipe(map(accessLevel => accessLevel === 'view_only'));
      })
    )
  );

  iconColor = computed(() => {
    if (this.viewOnly()) return 'primary';
    return 'grey';
  });

  constructor() {
    effect(() => {
      const _viewOnly = this._viewOnly();
      this.viewOnly.set(_viewOnly);
    });
  }

  toggle(value: boolean) {
    this.galleryService.updateGallery(this.gallery(), {
      public_access: value ? 'view_only' : 'review',
    });
  }
}
